
import React from 'react';
import getLocation from '../hooks/getLocation';
import {getQuery,getPath} from '../hooks/getQuery';
import {  BrowserRouter as Router,  useLocation,    useParams, useRouteMatch} from "react-router-dom";
import {
  useState,
   useEffect
  } from 'react'

 import theme from '../theme';

function Fetch(props) {
  const { onFetch} = props;
  const search = new URLSearchParams(useLocation().search);
  const [fetched, setFetched] =  useState(false);
  const initial = getPath(process.env.NODE_ENV,theme.paths); 
   
  const [path] =  useState(initial); 
  const newMatch = useRouteMatch({
    path: `${path}/:id`,
    strict: false,
    sensitive: true,
  });

  const [match] =  useState(newMatch); 
 
  useEffect(() => {
    if(!fetched){  
      setFetched(true); 
      const  query = getQuery(search);

      // Load the path id as priority 
      const id = match && match.params ? match.params.id:undefined; 
      if(id){
        query.id =id; 
      }   

      // override the view accord to path that come from meta
      if(path.includes('store')){
         query.view='store'; 
      }else if(path.includes('qr')){
        query.view='qr'; 
      }else if(path.includes('ticket')){
         query.view='ticket'; 
      }else if(path.includes('local')){
          query.view='local';  
      }else if(path.includes('webapp')){
        query.view = query.view; 
      }else{
        query.view='qr'; 
      }

      const params = {
        ... query,
        path:path,
      }

  
      getLocation(params, onFetch);
    };    
  }, []); 
  
  return "";
}

export default  function FetchLocation(props){
  const { onFetch,path } = props;
  return (<Router>
          <Fetch onFetch={onFetch}/>
          </Router>
  )
}
